export interface DrawioLinkOptions {
  title?: string;
  ui?: 'kennedy' | 'min' | 'atlas' | 'dark' | 'sketch' | 'simple';
}

/**
 * Build a shareable draw.io link preloaded with mermaid content.
 */
export function drawioMermaidLink(
  mermaidText: string,
  { title = 'Diagram', ui = 'kennedy' }: DrawioLinkOptions = {},
): string {
  const sanitizedDiagram = (mermaidText ?? '').trim();
  const sanitizedTitle = title && title.trim().length > 0 ? title.trim() : 'BA Genie - Diagram';
  const payload = encodeURIComponent(
    JSON.stringify({ type: 'mermaid', data: sanitizedDiagram }),
  );

  return `https://app.diagrams.net/?ui=${encodeURIComponent(ui)}&splash=0&title=${encodeURIComponent(
    sanitizedTitle,
  )}&create=${payload}`;
}
